import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=26682d0d&scoped=true&"
import script from "./ProductPage.vue?vue&type=script&lang=js&"
export * from "./ProductPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26682d0d",
  null
  
)

export default component.exports